import { AddBlock, Config } from '@clearkit/icons';
import { CKBox, CKButton, CKDrawer } from 'clearkit';

import { CustomObject } from '~/generated/graphql';

import FieldMappingForm from '../Show/FieldMappingForm';
import { ConfiguredCustomObjectsTable } from './ConfiguredCustomObjectsTable';
import { CustomObjectsContainer } from './Container';
import { Empty } from './Empty';
import { LinkingForm } from './LinkingForm';
import { SelectCustomObject } from './SelectCustomObject';
import { Send, State } from './useStateMachine/types';
import { customObjectToFullObjectType } from './util';

type ConfigureProps = {
  state: State;
  send: Send;
};
export function Configure({ state, send }: ConfigureProps) {
  if (!state.context.objects?.length) {
    return <Empty onRetry={() => send('RETRY')} />;
  }

  return (
    <CustomObjectsContainer>
      <CKBox className="px-5 py-4" variant="card">
        <div className="justify-between lg:flex">
          <div className="w-full mb-2 lg:w-96 lg:mb-0">
            <SelectCustomObject
              items={state.context.enabledObjects}
              onChange={(object) => send('BEGIN_CONFIGURING', { object })}
              value={state.context.selectedObject}
            />
          </div>
          <CKButton
            leftIcon={<Config />}
            onClick={() => send('BEGIN_MANAGING')}
            variantColor="blue"
          >
            Manage linked custom objects
          </CKButton>
        </div>
      </CKBox>
      <CKDrawer
        isVisible={state.matches('managing')}
        onToggle={() => send('CANCEL')}
      >
        <CKDrawer.Header>
          <CKDrawer.Heading>Salesforce custom objects</CKDrawer.Heading>
        </CKDrawer.Header>
        <CKDrawer.Body className="px-6 py-4 bg-gray-50">
          <p className="mb-4 text-sm text-gray-700">
            Link Salesforce custom objects you'd like Clearbit to enrich.
          </p>
          <ConfiguredCustomObjectsTable
            items={state.context.enabledObjects}
            onDisable={(object: CustomObject) =>
              send('REMOVE_OBJECT', { object })
            }
          />
          {state.context.isEmptyState ? null : (
            <CKButton
              leftIcon={<AddBlock />}
              onClick={() => send('BEGIN_LINKING')}
              variantColor="blue"
            >
              Link another custom object
            </CKButton>
          )}
          <LinkingForm send={send} state={state} />
        </CKDrawer.Body>
      </CKDrawer>
      {state.matches('configuring') ? (
        <FieldMappingForm
          integration="salesforce"
          objectType={customObjectToFullObjectType(
            state.context.selectedObject,
          )}
        />
      ) : null}
    </CustomObjectsContainer>
  );
}
